import React from 'react';
import BackBtn from '../../Shared/BackBtn/BackBtn';

// this is a upcomming componet
const Payment = () => {
    return (
        <div>
            <h3>Payment System is comming soon</h3>
            <BackBtn/>
        </div>
    );
};

export default Payment;